import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LenderProfileList } from "./lenders/LenderProfileList";
import { LenderDashboard } from "./lenders/LenderDashboard";
import { TransactionAssignment } from "./lenders/TransactionAssignment";
import { AdminBankConnection } from "./lenders/AdminBankConnection";

export const LenderManagement = () => {
  const [activeTab, setActiveTab] = useState("profiles");

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Lender Management</h2>
        <p className="text-muted-foreground">
          Manage lender profiles
        </p>
      </div>

      <LenderProfileList />
    </div>
  );
};
